/* CrispyCards Sticky Desktop Header – Toolbar + Hauptnavigation, ohne TCG-Slider */
(() => {
  'use strict';


  // CartDrawer aus dem Header-Stapelkontext herausnehmen.
  // Die Impulse-Events und der bestehende Cart bleiben unverändert.
  function placeCartDrawerAtBodyLevel() {
    const drawer = document.getElementById('CartDrawer');
    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
  }

  // Auch das mobile Navigationsmenü darf nicht im Stapelkontext
  // der Header-Section gefangen bleiben.
  function placeNavDrawerAtBodyLevel() {
    const drawer = document.getElementById('NavDrawer');
    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
  }


  // V4: Sticky-Filterleisten am echten Header-Abstand ausrichten.
  // Nur schmale, linksstehende sticky Elemente im Hauptinhalt mit
  // Filter-Steuerelementen werden angepasst (keine Popups oder Navigation).
  function alignStickyCollectionFilters() {
    document.querySelectorAll('.cc-filter-sticky-offset').forEach((el) => {
      el.classList.remove('cc-filter-sticky-offset');
    });
    if (window.innerWidth <= 768) return;
    const main = document.querySelector('#MainContent, main#MainContent, main.main-content, .main-content');
    if (!main) return;
    const candidates = main.querySelectorAll('aside, [class*="filter"], [class*="Filter"], [class*="sidebar"], [class*="Sidebar"], [style*="sticky"]');
    const found = new Set();
    const viewportWidth = window.innerWidth;
    for (const element of candidates) {
      let node = element;
      for (let level = 0; node && node !== main && level < 5; level++, node = node.parentElement) {
        if (found.has(node)) break;
        if (getComputedStyle(node).position !== 'sticky') continue;
        const rect = node.getBoundingClientRect();
        if (rect.width < 100 || rect.width > viewportWidth * 0.38 || rect.left > viewportWidth * 0.42) continue;
        if (!node.querySelector('input[type="checkbox"], input[type="radio"], [role="checkbox"], .tag-list, [class*="filter"], [class*="Filter"]')) continue;
        node.classList.add('cc-filter-sticky-offset');
        found.add(node);
        break;
      }
    }
  }
  function initFilterOffset() {
    alignStickyCollectionFilters();
    window.addEventListener('resize', alignStickyCollectionFilters, {passive: true});
    document.addEventListener('shopify:section:load', alignStickyCollectionFilters);
    // Collection-Filter werden teils nach einem AJAX-Update ersetzt.
    const main = document.querySelector('#MainContent, main#MainContent, main.main-content, .main-content');
    if (main && 'MutationObserver' in window) {
      let queued = false;
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => { queued = false; alignStickyCollectionFilters(); });
      }).observe(main, {childList: true, subtree: true});
    }
  }

  function init() {
    placeCartDrawerAtBodyLevel();
    placeNavDrawerAtBodyLevel();
    if (!document.documentElement.dataset.ccFilterOffsetReady) {
      document.documentElement.dataset.ccFilterOffsetReady = "true";
      initFilterOffset();
    }
    document.querySelectorAll('.cc-header-desktop').forEach((root) => {
      if (root.dataset.ccStickyReady === 'true') return;
      const main = root.querySelector('.cc-header-main');
      if (!main) return;
      const toolbar = root.querySelector('.toolbar');
      root.dataset.ccStickyReady = 'true';

      const first = toolbar || main;
      const placeholderMain = document.createElement('div');
      placeholderMain.className = 'cc-sticky-placeholder';
      placeholderMain.setAttribute('aria-hidden', 'true');
      main.after(placeholderMain);

      let placeholderToolbar;
      if (toolbar) {
        placeholderToolbar = document.createElement('div');
        placeholderToolbar.className = 'cc-sticky-placeholder';
        placeholderToolbar.setAttribute('aria-hidden', 'true');
        toolbar.after(placeholderToolbar);
      }

      // Der erste Block bleibt als Anker im Dokument, auch wenn der Header fixiert ist.
      const anchor = document.createElement('span');
      anchor.style.cssText = 'display:block;height:0;width:0;pointer-events:none';
      first.before(anchor);

      let frame = null;
      function update() {
        if (frame !== null) cancelAnimationFrame(frame);
        frame = null;
        if (window.innerWidth <= 768) {
          root.classList.remove('cc-top-stuck');
          return;
        }

        const mainHeight = main.getBoundingClientRect().height;
        const toolbarHeight = toolbar ? toolbar.getBoundingClientRect().height : 0;
        placeholderMain.style.height = `${mainHeight}px`;
        if (placeholderToolbar) placeholderToolbar.style.height = `${toolbarHeight}px`;
        root.style.setProperty('--cc-sticky-toolbar-height', `${toolbarHeight}px`);
        // Höhe des ständig sichtbaren Desktop-Headers für PhotoSwipe bereitstellen.
        document.documentElement.style.setProperty('--cc-visible-header-height', `${Math.ceil(toolbarHeight + mainHeight)}px`);

        // Der Anker bleibt in der normalen Dokumentposition.
        // Direkt beim Beginn des Scrollens beide Header-Zeilen gleichzeitig fixieren.
        // Der vorherige Anker + requestAnimationFrame konnte an der Schwelle
        // eine sichtbare Luecke zwischen Toolbar und Hauptheader erzeugen.
        const shouldStick = window.scrollY > 1;
        root.classList.toggle('cc-top-stuck', shouldStick);
      }

      function schedule() {
        if (frame !== null) return;
        frame = requestAnimationFrame(update);
      }
      // Scroll-Umschaltung synchron: kein einzelner Frame mit fehlender Toolbar.
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(root)) {
          window.removeEventListener('scroll', update);
          window.removeEventListener('resize', schedule);
        }
      });
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else init();
  document.addEventListener('shopify:section:load', init);
})();
